module.exports = __webpack_public_path__ + "assets/images/minus_gray.svg?c600dd11ca6851d925606bbd88c4b8e5";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/minus_gray.svg
// module id = 608
// module chunks = 0